<template>
    <div>
        <div class="white-box flex space-between align-center">
            <div>
                <h3 class="module-title m-0">Am replicat pentru tine interfața MySMIS - îți recomandăm să utilizezi doua monitoare și să urmărești secțiunile</h3>
            </div>
        </div>
        <div class="white-box flex mt-3">
            <MySmisMenu class="menu-left"></MySmisMenu>
            <MySmisPageContent class="page-right" :allData="allData"></MySmisPageContent>
        </div>
        <MySmisPopup :mysmisPopup="modalShow" @hideTempModal="hideModal()">
        </MySmisPopup>
    </div>
</template>

<script>
import MySmisMenu from '@/pages/Aplicatii/M3/M3Sketch/components/mysmis/MySmisMenu'
import MySmisPageContent from '@/pages/Aplicatii/M3/M3Sketch/components/mysmis/MySmisPageContent'
import MySmisPopup from '@/pages/Aplicatii/M3/M3Sketch/components/mysmis/MySmisPopup'

export default {
    components: {
        MySmisMenu,
        MySmisPageContent,
        MySmisPopup,
    },
    data() {
        return {
            modalShow: false,
        }
    },
    computed: {
        allData() {
            return this.$store.getters['m3Sketch/allData']
        }
    },
    mounted() {

        if(!JSON.parse(localStorage.getItem('MySmisProjectNotice'))){
            this.modalShow = true
        }
    },
    methods: {
        hideModal() {
            this.modalShow = false
            localStorage.setItem('MySmisProjectNotice', true)
        }
    }
}
</script>

<style scoped>
.space-between{
    justify-content: space-between;
}
.white-box{
    background: #fff;
    padding: 20px;
}
.module-title{
    margin: 0;
    color: #5b6276;
    font-size: 14px;
    margin-bottom: 5px;
}
.white-box{
    width: 100%;
}
.white-box p{
    color: #777e90;
    font-size: 12px;
    margin: 0;
    max-width: 960px;
}
.menu-left{
    width: 100%;
    max-width: 200px;
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-right: 20px;
}
.page-right{
    width: 100%;
}
</style>
